// Shared inline-style tokens for the PerformanceCharts island. Mirrors the
// CSS-variable token approach used by AiDebrief — every value falls back to a
// literal so the chart renders even outside the dashboard's token scope.
export const tokens = {
  accent:     "var(--accent, #0b6b7a)",
  accentInk:  "var(--accent-ink, #0b6b7a)",
  ink900:     "var(--ink-900, #0b1420)",
  ink700:     "var(--ink-700, #2b3440)",
  ink500:     "var(--ink-500, #6b7480)",
  ink400:     "var(--ink-400, #9aa3ad)",
  ink300:     "var(--ink-300, #c3c9d2)",
  ink200:     "var(--ink-200, #e3e6ec)",
  paper:      "var(--paper, #fff)",
  surface:    "var(--surface-50, #f6f8fa)",
  ui:         "var(--ui, system-ui)",
};

export const styles = {
  shell: {
    fontFamily: tokens.ui,
    margin: "28px 0 0",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "16px",
  },
  eyebrow: {
    fontSize: "12px",
    fontWeight: 700,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    color: tokens.accentInk,
  },
  subtitle: {
    margin: "2px 0 0",
    fontSize: "13px",
    color: tokens.ink500,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "16px",
  },
  card: {
    border: `1px solid ${tokens.ink200}`,
    borderRadius: "12px",
    background: tokens.paper,
    padding: "18px 20px",
  },
  cardTitle: {
    fontSize: "14px",
    fontWeight: 700,
    color: tokens.ink900,
    margin: "0 0 4px",
  },
  cardHint: {
    fontSize: "12px",
    color: tokens.ink500,
    margin: "0 0 14px",
  },
  bigStat: {
    fontSize: "30px",
    fontWeight: 800,
    color: tokens.accentInk,
    lineHeight: 1.1,
  },
  bigStatCaption: {
    fontSize: "13px",
    color: tokens.ink700,
    margin: "4px 0 12px",
  },
  empty: {
    fontSize: "13px",
    color: tokens.ink500,
    lineHeight: 1.5,
    margin: 0,
    padding: "24px 4px",
  },
  loading: {
    fontSize: "14px",
    color: tokens.ink500,
    padding: "32px 4px",
  },
  legend: {
    display: "flex",
    gap: "16px",
    margin: "10px 0 0",
    fontSize: "12px",
    color: tokens.ink500,
  },
  legendDot: (color) => ({
    display: "inline-block",
    width: "10px",
    height: "10px",
    borderRadius: "2px",
    background: color,
    marginRight: "6px",
    verticalAlign: "middle",
  }),
};
